"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var joi_1 = __importDefault(require("joi"));
var validate_1 = __importDefault(require("./validate"));
var patterns = {
    number: /^\d+$/,
    string: /.+/,
    ObjectId: /[\da-f]{24}$/,
};
function getStorageSchema(pattern, schema) {
    var patt = typeof pattern === "string" ? patterns[pattern] || pattern : pattern;
    return joi_1.default.object().pattern(patt, joi_1.default.object({
        info: schema.required(),
        loadTime: joi_1.default.date(),
    }).unknown(true));
}
exports.getStorageSchema = getStorageSchema;
exports.validateStorage = function (pattern, schema) {
    var itemSchema = getStorageSchema(pattern, schema);
    return function (items) {
        return validate_1.default(items, itemSchema, {
            stripUnknown: true,
        });
    };
};
